import { HISTORY_MODULE_NAME } from '@src/slide/application/service/history-manager/core/constants';
import { IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';

export default class HistoryMobileModule {
    private drawer: HTMLDivElement;

    public constructor(private historyManager: IHistoryManager) {
        this.init();
    }

    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    public get name() {
        return HISTORY_MODULE_NAME;
    }

    public get drawerNode() {
        return this.drawer;
    }

    public async show() {
        this.historyManager.showModule(this.drawer as Element, () => {
            this.showWrapper();
        }, () => {
            this.hideWrapper();
        });
    }

    private init() {
        const drawerStyles = {
            position: 'fixed',
            top: '0',
            right: '0',
            width: '100vw',
            height: '100vh',
            backgroundolor: '#ffffff',
            zIndex: '9997',
            transform: 'translateX(100%)',
            transition: 'transform 0.3s ease-in-out',
        };
        this.drawer = document.createElement('div');
        this.drawer.id = this.name;
        this.drawer.style.cssText = Object.entries(drawerStyles)
            .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value};`)
            .join(' ');
        document.body.appendChild(this.drawer);
    }

    private showWrapper() {
        this.drawer.style.transform = 'translateX(0)';
    }

    private hideWrapper() {
        this.drawer.style.transform = 'translateX(100%)';
        this.historyManager.hideModule(this.drawer as Element);
    }
}
